import axios from "axios";

axios.defaults.baseURL = "https://xeniamailsender.onrender.com/";

export const SendMail = async (data) => {
  const SendMailUrl = "mobipos/send-email";
  try {
    const response = await axios.post(SendMailUrl, data);
    return response;
  } catch (error) {
    throw error;
  }
};
